import React from "react"
import { View } from "react-native"
import { Spacer } from "@Components/Space"
import styles from "./styles"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import { Text } from "react-native-paper"
import { uniqBy } from "lodash"

const ConclusionSkills = ({ isGoals, skills, title, goals }) => {
    const data = isGoals ? goals?.flat(2) : skills
    const filteredData = uniqBy(data, "id") ?? []

    return (
        <View
            style={[
                styles.container,
                { backgroundColor: baseColors.green.light, paddingHorizontal: 30, paddingTop: 20 }
            ]}
        >
            <Text
                style={{
                    marginBottom: 10,
                    fontSize: 14,
                    fontFamily: baseFontFamily.OpenSansSemiBold,
                    color: baseColors.green.primary
                }}
            >
                {title ?? ""}
            </Text>

            {filteredData?.map((item) => (
                <View key={item?.id} style={{ flexDirection: "row", alignItems: "center", marginBottom: 15 }}>
                    <View
                        style={{ height: 7, width: 7, borderRadius: 10, backgroundColor: baseColors.orange.primary }}
                    />

                    <Text
                        style={{
                            flex: 1,
                            left: 10,
                            fontSize: 12,
                            fontFamily: baseFontFamily.OpenSansSemiBold,
                            color: baseColors.black
                        }}
                    >
                        {item?.name ?? item?.goal ?? ""}
                    </Text>
                </View>
            ))}

            <Spacer height={20} />
        </View>
    )
}

export default ConclusionSkills
